BX.ready(function () {

    var sku_props = BX.findChildren(BX('basket_items'), {tagName: 'li', className: 'sku_prop'}, true);
    if (!!sku_props && sku_props.length > 0) {
        for (i = 0; sku_props.length > i; i++) {
            BX.bind(sku_props[i], 'click', BX.delegate(function (e) {
                skuPropClickHandler(e);
            }, this));
        }
    }
});

function skuPropClickHandler(e) {
    if (!e)
        e = window.event;
    var target = BX.proxy_context;

    if (!!target && target.hasAttribute('data-value-id')) {
        BX.showWait();

        var basketItemId = target.getAttribute('data-element'),
            property = target.getAttribute('data-property'),
            property_values = {},
            postData = {},
            action_var = BX('action_var').value;

        property_values[property] = target.getAttribute('data-value-id');

        // if already selected element is clicked
        if (BX.hasClass(target, 'bx_active')) {
            BX.closeWait();
            return;
        }

        // get other basket item props to get full unique set of props of the new product
        var all_sku_props = BX.findChildren(BX(basketItemId), {tagName: 'ul', className: 'sku_prop_list'}, true);
        if (!!all_sku_props && all_sku_props.length > 0) {
            for (var i = 0; all_sku_props.length > i; i++) {
                if (all_sku_props[i].id == 'prop_' + property + '_' + basketItemId) {
                    continue;
                }
                else {
                    var sku_prop_value = BX.findChildren(BX(all_sku_props[i].id), {
                        tagName: 'li',
                        className: 'bx_active'
                    }, true);
                    if (!!sku_prop_value && sku_prop_value.length > 0) {
                        for (var m = 0; sku_prop_value.length > m; m++) {
                            if (sku_prop_value[m].hasAttribute('data-value-id'))
                                property_values[sku_prop_value[m].getAttribute('data-property')] = sku_prop_value[m].getAttribute('data-value-id');
                        }
                    }
                }
            }
        }

        postData = {
            'basketItemId': basketItemId,
            'sessid': BX.bitrix_sessid(),
            'site_id': BX.message('SITE_ID'),
            'props': property_values,
            'action_var': action_var,
            'select_props': BX('column_headers').value,
            'offers_props': BX('offers_props').value,
            'quantity_float': BX('quantity_float').value,
            'count_discount_4_all_quantity': BX('count_discount_4_all_quantity').value,
            'price_vat_show_value': BX('price_vat_show_value').value,
            'hide_coupon': BX('hide_coupon').value,
            'use_prepayment': BX('use_prepayment').value
        };

        postData[action_var] = 'select_item';

        BX.ajax({
            url: '/bitrix/components/bitrix/sale.basket.basket/ajax.php',
            method: 'POST',
            data: postData,
            dataType: 'json',
            onsuccess: function (result) {
                BX.closeWait();
                updateBasketTable(basketItemId, result);
            }
        });
    }
}

function updateBasketTable(basketItemId, res, postData) {

    var table = BX("basket_items_table");
    if (!table)
        return;

    var rows = table.rows;
    var newBasketItemId = res['BASKET_ID'];
    if (res['BASKET_DATA']['GRID']['ROWS'] != undefined) {
        var arItem = res['BASKET_DATA']['GRID']['ROWS'][newBasketItemId];
    }
    var lastRow = rows[rows.length - 1];

    var newRow = document.createElement('tr');

    var arColumns = res['COLUMNS'].split(',');

    var bShowDeleteColumn = false;
    var bShowDelayColumn = false;
    var bShowPropsColumn = false;
    var bShowPriceType = false;
    var bUseFloatQuantity = (res['PARAMS']['QUANTITY_FLOAT'] == 'Y') ? true : false;
    // insert new row instead of original basket item row
    if (basketItemId !== null) {
        var origBasketItem = BX(basketItemId);

        newRow.setAttribute('id', res['BASKET_ID']);
        lastRow.parentNode.insertBefore(newRow, origBasketItem.nextSibling);

        if (res['DELETE_ORIGINAL'] == 'Y')
            origBasketItem.parentNode.removeChild(origBasketItem);

        // fill row with fields' values
        var oCellMargin = newRow.insertCell(-1);
        oCellMargin.setAttribute('class', 'margin');

        for (i = 0; i < arColumns.length; i++) {
            if (arColumns[i] == 'DELETE')
                bShowDeleteColumn = true;

            if (arColumns[i] == 'DELAY')
                bShowDelayColumn = true;

            if (arColumns[i] == 'PROPS')
                bShowPropsColumn = true;

            if (arColumns[i] == 'TYPE')
                bShowPriceType = true;
        }

        for (i = 0; i < arColumns.length; i++) {
            if (arColumns[i] == 'PROPS' || arColumns[i] == 'DELAY' || arColumns[i] == 'DELETE' || arColumns[i] == 'TYPE')
                continue;


            if (arColumns[i] == 'NAME') {
                // first <td> - image and brand
                var oCellName = newRow.insertCell(-1),
                    imageURL = '',
                    cellNameHTML = '';

                oCellName.setAttribute('class', 'itemphoto');

                if (arItem['PREVIEW_PICTURE_SRC'].length > 0)
                    imageURL = arItem['PREVIEW_PICTURE_SRC'];
                else if (arItem['DETAIL_PICTURE_SRC'].length > 0)
                    imageURL = arItem['DETAIL_PICTURE_SRC'];
                else
                    imageURL = basketJSParams['TEMPLATE_FOLDER'] + '/images/no_photo.png';

                if (arItem['DETAIL_PAGE_URL'].length > 0) {
                    cellNameHTML = '<div class="bx_ordercart_photo_container">\
						<a href="' + arItem['DETAIL_PAGE_URL'] + '">\
							<div class="bx_ordercart_photo" style="background-image:url(\'' + imageURL + '\')"></div>\
						</a>\
					</div>';
                }
                else {
                    cellNameHTML = '<div class="bx_ordercart_photo_container">\
						<div class="bx_ordercart_photo" style="background-image:url(\'' + imageURL + '\')"></div>\
					</div>';
                }

                if (arItem['BRAND'] && arItem['BRAND'].length > 0) {
                    cellNameHTML += '<div class="bx_ordercart_brand">\
						<img alt="" src="' + arItem['BRAND'] + '"/>\
					</div>';
                }

                oCellName.innerHTML = cellNameHTML;

                // second <td> - name, basket props, sku props
                var oCellItem = newRow.insertCell(-1),
                    cellItemHTML = '';
                oCellItem.setAttribute('class', 'item');

                if (arItem['DETAIL_PAGE_URL'].length > 0)
                    cellItemHTML += '<h2 class="bx_ordercart_itemtitle"><a href="' + arItem['DETAIL_PAGE_URL'] + '">' + arItem['NAME'] + '</a></h2>';
                else
                    cellItemHTML += '<h2 class="bx_ordercart_itemtitle">' + arItem['NAME'] + '</h2>';

                cellItemHTML += '<div class="bx_ordercart_itemart">';

                if (bShowPropsColumn) {
                    var bSkip;
                    for (var j = 0; j < arItem['PROPS'].length; j++) {
                        var val = arItem['PROPS'][j];

                        if (arItem.SKU_DATA) {
                            bSkip = false;
                            for (var propId in arItem.SKU_DATA) {
                                if (arItem.SKU_DATA.hasOwnProperty(propId)) {
                                    var arProp = arItem.SKU_DATA[propId];

                                    if (arProp['CODE'] == val['CODE']) {
                                        bSkip = true;
                                        break;
                                    }
                                }
                            }
                            if (bSkip)
                                continue;
                        }

                        cellItemHTML += val['NAME'] + ':&nbsp;<span>' + val['VALUE'] + '</span><br/>';
                    }
                    ;
                }
                cellItemHTML += '</div>';

                if (arItem.SKU_DATA) {
                    var arProp, bIsImageProperty, full, arVal;

                    for (var propId in arItem.SKU_DATA) {
                        if (arItem.SKU_DATA.hasOwnProperty(propId)) {
                            arProp = arItem.SKU_DATA[propId];
                            bIsImageProperty = false;
                            full = (BX.util.array_keys(arProp['VALUES']).length > 5) ? 'full' : '';

                            for (var valId in arProp['VALUES']) {
                                arVal = arProp['VALUES'][valId];

                                if (arVal['PICT'] !== false) {
                                    bIsImageProperty = true;
                                    break;
                                }
                            }

                            // sku property can contain list of images or values
                            if (bIsImageProperty) {
                                cellItemHTML += '<div class="bx_item_detail_scu_small_noadaptive ' + full + '">';
                                cellItemHTML += '<span class="bx_item_section_name_gray">' + arProp['NAME'] + '</span>';
                                cellItemHTML += '<div class="bx_scu_scroller_container">';
                                cellItemHTML += '<div class="bx_scu">';

                                cellItemHTML += '<ul id="prop_' + arProp['CODE'] + '_' + arItem['ID'] + '" style="width: 200%; margin-left:0%;" class="sku_prop_list">';

                                var arSkuValue, selected;

                                for (var valueId in arProp['VALUES']) {
                                    arSkuValue = arProp['VALUES'][valueId];
                                    selected = '';

                                    // get current selected item
                                    for (var k = 0; k < arItem['PROPS'].length; k++) {
                                        var arItemProp = arItem['PROPS'][k];

                                        if (arItemProp['CODE'] == arProp['CODE']) {
                                            if (arItemProp['VALUE'] == arSkuValue['NAME'] || arItemProp['VALUE'] == arSkuValue['XML_ID'])
                                                selected = 'bx_active';
                                        }
                                    }

                                    cellItemHTML += '<li style="width:10%;"\
														class="sku_prop ' + selected + '"\
														data-value-id="' + arSkuValue['XML_ID'] + '"\
														data-element="' + arItem['ID'] + '"\
														data-property="' + arProp['CODE'] + '"\
														>\
														<a href="javascript:void(0);">\
															<span style="background-image:url(' + arSkuValue['PICT']['SRC'] + ')"></span>\
														</a>\
													</li>';
                                }

                                cellItemHTML += '</ul>';
                                cellItemHTML += '</div>';

                                cellItemHTML += '<div class="bx_slide_left" onclick="leftScroll(\'' + arProp['CODE'] + '\', ' + arItem['ID'] + ', ' + BX.util.array_keys(arProp['VALUES']).length + ');"></div>';
                                cellItemHTML += '<div class="bx_slide_right" onclick="rightScroll(\'' + arProp['CODE'] + '\', ' + arItem['ID'] + ', ' + BX.util.array_keys(arProp['VALUES']).length + ');"></div>';

                                cellItemHTML += '</div>';
                                cellItemHTML += '</div>';
                            }
                            else // not image
                            {
                                cellItemHTML += '<div class="bx_item_detail_size_small_noadaptive ' + full + '">';
                                cellItemHTML += '<span class="bx_item_section_name_gray">' + arProp['NAME'] + '</span>';
                                cellItemHTML += '<div class="bx_size_scroller_container">';
                                cellItemHTML += '<div class="bx_size">';

                                cellItemHTML += '<ul id="prop_' + arProp['CODE'] + '_' + arItem['ID'] + '" style="width: 200%; margin-left:0%;" class="sku_prop_list">';

                                for (var valueId in arProp['VALUES']) {
                                    var arSkuValue = arProp['VALUES'][valueId],
                                        selected = '';

                                    // get current selected item
                                    for (var k = 0; k < arItem['PROPS'].length; k++) {
                                        var arItemProp = arItem['PROPS'][k];

                                        if (arItemProp['CODE'] == arProp['CODE']) {
                                            if (arItemProp['VALUE'] == arSkuValue['NAME'])
                                                selected = 'bx_active';
                                        }
                                    }

                                    cellItemHTML += '<li style="width:10%;"\
														class="sku_prop ' + selected + '"\
														data-value-id="' + arSkuValue['NAME'] + '"\
														data-element="' + arItem['ID'] + '"\
														data-property="' + arProp['CODE'] + '"\
														>\
														<a href="javascript:void(0);">' + arSkuValue['NAME'] + '</span></a>\
													</li>';
                                }

                                cellItemHTML += '</ul>';
                                cellItemHTML += '</div>';

                                cellItemHTML += '<div class="bx_slide_left" onclick="leftScroll(\'' + arProp['CODE'] + '\', ' + arItem['ID'] + ', ' + BX.util.array_keys(arProp['VALUES']).length + ');"></div>';
                                cellItemHTML += '<div class="bx_slide_right" onclick="rightScroll(\'' + arProp['CODE'] + '\', ' + arItem['ID'] + ', ' + BX.util.array_keys(arProp['VALUES']).length + ');"></div>';

                                cellItemHTML += '</div>';
                                cellItemHTML += '</div>';
                            }
                        }
                    }
                }

                oCellItem.innerHTML = cellItemHTML;
            }
            else if (arColumns[i] == 'QUANTITY') {
                var oCellQuantity = newRow.insertCell(-1),
                    oCellQuantityHTML = '',
                    ratio = (parseFloat(arItem['MEASURE_RATIO']) > 0) ? arItem['MEASURE_RATIO'] : 1,
                    max = (parseFloat(arItem['AVAILABLE_QUANTITY']) > 0) ? 'max="' + arItem['AVAILABLE_QUANTITY'] + '"' : '';


                var isUpdateQuantity = false;

                if (ratio != 0 && ratio != '') {
                    var oldQuantity = arItem['QUANTITY'];
                    arItem['QUANTITY'] = getCorrectRatioQuantity(arItem['QUANTITY'], ratio, bUseFloatQuantity);

                    if (oldQuantity != arItem['QUANTITY']) {
                        isUpdateQuantity = true;
                    }
                }

                oCellQuantity.setAttribute('class', 'custom');
                oCellQuantityHTML += '<span>' + getColumnName(res, arColumns[i]) + ':</span>';

                oCellQuantityHTML += '<div class="centered">';
                oCellQuantityHTML += '<table cellspacing="0" cellpadding="0" class="counter">';
                oCellQuantityHTML += '<tr>';
                oCellQuantityHTML += '<td>';

                oCellQuantityHTML += '<input\
										type="text"\
										size="3"\
										id="QUANTITY_INPUT_' + arItem['ID'] + '"\
										name="QUANTITY_INPUT_' + arItem['ID'] + '"\
										size="2"\
										maxlength="18"\
										min="0"\
										' + max + '\
										step=' + ratio + '\
										style="max-width: 50px"\
										value="' + arItem['QUANTITY'] + '"\
										onchange="updateQuantity(\'QUANTITY_INPUT_' + arItem['ID'] + '\',\'' + arItem['ID'] + '\', ' + ratio + ',' + bUseFloatQuantity + ')"\
					>';

                oCellQuantityHTML += '</td>';

                if (ratio != 0
                    && ratio != ''
                ) // if not Set parent, show quantity control
                {
                    oCellQuantityHTML += '<td id="basket_quantity_control">\
						<div class="basket_quantity_control">\
							<a href="javascript:void(0);" class="plus" onclick="setQuantity(' + arItem['ID'] + ', ' + ratio + ', \'up\', ' + bUseFloatQuantity + ');"></a>\
							<a href="javascript:void(0);" class="minus" onclick="setQuantity(' + arItem['ID'] + ', ' + ratio + ', \'down\', ' + bUseFloatQuantity + ');"></a>\
						</div>\
					</td>';
                }

                if (arItem.hasOwnProperty('MEASURE_TEXT') && arItem['MEASURE_TEXT'].length > 0)
                    oCellQuantityHTML += '<td style="text-align: left">' + arItem['MEASURE_TEXT'] + '</td>';

                oCellQuantityHTML += '</tr>';
                oCellQuantityHTML += '</table>';
                oCellQuantityHTML += '</div>';

                oCellQuantityHTML += '<input type="hidden" id="QUANTITY_' + arItem['ID'] + '" name="QUANTITY_' + arItem['ID'] + '" value="' + arItem['QUANTITY'] + '" />';

                oCellQuantity.innerHTML = oCellQuantityHTML;

                if (isUpdateQuantity) {
                    updateQuantity('QUANTITY_INPUT_' + arItem['ID'], arItem['ID'], ratio, bUseFloatQuantity);
                }
            }
            else if (arColumns[i] == 'PRICE') {
                var oCellPrice = newRow.insertCell(-1),
                    fullPrice = (arItem['FULL_PRICE_FORMATED'] != arItem['PRICE_FORMATED']) ? arItem['FULL_PRICE_FORMATED'] : '';

                oCellPrice.setAttribute('class', 'price');
                oCellPrice.innerHTML += '<div class="current_price" id="current_price_' + arItem['ID'] + '">' + arItem['PRICE_FORMATED'] + '</div>';
                oCellPrice.innerHTML += '<div class="old_price" id="old_price_' + arItem['ID'] + '">' + fullPrice + '</div>';

                if (bShowPriceType && arItem['NOTES'].length > 0) {
                    oCellPrice.innerHTML += '<div class="type_price">' + basketJSParams['SALE_TYPE'] + '</div>';
                    oCellPrice.innerHTML += '<div class="type_price_value">' + arItem['NOTES'] + '</div>';
                }
            }
            else if (arColumns[i] == 'DISCOUNT') {
                var oCellDiscount = newRow.insertCell(-1);
                oCellDiscount.setAttribute('class', 'custom');
                oCellDiscount.innerHTML = '<span>' + getColumnName(res, arColumns[i]) + ':</span>';
                oCellDiscount.innerHTML += '<div id="discount_value_' + arItem['ID'] + '">' + arItem['DISCOUNT_PRICE_PERCENT_FORMATED'] + '</div>';
            }
            else if (arColumns[i] == 'WEIGHT') {
                var oCellWeight = newRow.insertCell(-1);
                oCellWeight.setAttribute('class', 'custom');
                oCellWeight.innerHTML = '<span>' + getColumnName(res, arColumns[i]) + ':</span>';
                oCellWeight.innerHTML += arItem['WEIGHT_FORMATED'];
            }
            else {
                var oCellCustom = newRow.insertCell(-1),
                    customColumnVal = '';

                oCellCustom.setAttribute('class', 'custom');
                oCellCustom.innerHTML = '<span>' + getColumnName(res, arColumns[i]) + ':</span>';

                if (arColumns[i] == 'SUM')
                    customColumnVal += '<div id="sum_' + arItem['ID'] + '">';

                if (typeof (arItem[arColumns[i]]) != 'undefined') {
                    customColumnVal += arItem[arColumns[i]];
                }

                if (arColumns[i] == 'SUM')
                    customColumnVal += '</div>';

                oCellCustom.innerHTML += customColumnVal;
            }
        }

        if (bShowDeleteColumn || bShowDelayColumn) {
            var oCellControl = newRow.insertCell(-1);
            oCellControl.setAttribute('class', 'control');

            if (bShowDeleteColumn)
                oCellControl.innerHTML = '<a href="' + basketJSParams['DELETE_URL'].replace('#ID#', arItem['ID']) + '">' + basketJSParams['SALE_DELETE'] + '</a><br />';

            if (bShowDelayColumn)
                oCellControl.innerHTML += '<a href="' + basketJSParams['DELAY_URL'].replace('#ID#', arItem['ID']) + '">' + basketJSParams['SALE_DELAY'] + '</a>';
        }

        var oCellMargin2 = newRow.insertCell(-1);
        oCellMargin2.setAttribute('class', 'margin');

        // set sku props click handler
        var sku_props = BX.findChildren(BX(newBasketItemId), {tagName: 'li', className: 'sku_prop'}, true);
        if (!!sku_props && sku_props.length > 0) {
            for (i = 0; sku_props.length > i; i++) {
                BX.bind(sku_props[i], 'click', BX.delegate(function (e) {
                    skuPropClickHandler(e);
                }, this));
            }
        }
    }

    var all_QUANTITY = 0;
    // update product params after recalculation
    for (var id in res.BASKET_DATA.GRID.ROWS) {
		
        if (res.BASKET_DATA.GRID.ROWS.hasOwnProperty(id)) {
			
            var item = res.BASKET_DATA.GRID.ROWS[id];
			
			if (item.DELAY != "N" || item.CAN_BUY != "Y") continue;
			
            item_QUANTITY = +item.QUANTITY;
            all_QUANTITY = all_QUANTITY + item_QUANTITY;

            if (BX('discount_value_' + id))
                BX('discount_value_' + id).innerHTML = item.DISCOUNT_PRICE_PERCENT_FORMATED;

            if (BX('current_price_' + id))
                BX('current_price_' + id).innerHTML = item.PRICE_FORMATED;

            if (BX('discount_card') && item.PRICE < item.FULL_PRICE) {
                BX.addClass(BX('current_price_' + id), "selected-price");
                BX.removeClass(BX('price_' + id), "selected-price");
            }

            if (BX('old_price_' + id))
                BX('old_price_' + id).innerHTML = (item.FULL_PRICE_FORMATED != item.PRICE_FORMATED) ? item.FULL_PRICE_FORMATED : '';
			
			if (BX('price_' + id)){
                BX('price_' + id).innerHTML = item.FULL_PRICE_FORMATED;
                //BX('price_' + id).className = (item.PRICE != item.FULL_PRICE) ? 'old-price' : '';
			}
			
            if (BX('sum_' + id)){
				var old_sum = item.FULL_PRICE * item.QUANTITY;
				var old_sum_formated = numberFormat(Math.round(old_sum)) + ' руб.';
                BX('sum_' + id).innerHTML = old_sum_formated;
                BX('sum_' + id).className = (item.PRICE != item.FULL_PRICE) ? 'old-price' : '';
			}
			
			if (BX('discount_sum_' + id))
				BX('discount_sum_' + id).innerHTML = (item.PRICE != item.FULL_PRICE) ? item.SUM : '';
			
			if (BX('discount_price_' + id))
				BX('discount_price_' + id).innerHTML = (item.PRICE != item.FULL_PRICE) ? item.PRICE_FORMATED : '';
			
			if (BX('DISCOUNT_PRICE_PERCENT_' + id))
                BX('DISCOUNT_PRICE_PERCENT_' + id).innerHTML = (parseFloat(item.DISCOUNT_PRICE_PERCENT) > 0) ? item.DISCOUNT_PRICE_PERCENT_FORMATED : '';

            // if the quantity was set by user to 0 or was too much, we need to show corrected quantity value from ajax response
            if (BX('QUANTITY_' + id)) {
				
                if (postData['QUANTITY_' + id] > item.QUANTITY && item.AVAILABLE_QUANTITY != undefined) {
					
                    current_id = id;
                    var availCount = item.AVAILABLE_QUANTITY,
                        availTitle = DeclOfNum(item.AVAILABLE_QUANTITY, ['товар', 'товара', 'товаров']),
                        availWord = DeclOfNum(item.AVAILABLE_QUANTITY, ['доступен', 'доступно', 'доступно']),
                        block = $('.pop-available');
                    block.find('.count-available').text(availCount);
                    block.find('.count-title').text(availTitle);
                    block.find('.count-word').text(availWord);
                    showpop(block);

                    setTimeout(function () {
                        $('#warning-' + current_id).animate({
                            opacity: 0
                        }, 1000);
                        setTimeout(function () {
                            if ($('#warning-' + current_id).css('opacity') < 0.1) {
                                $('#warning-' + current_id).remove();
                            }
                        }, 1001);
                    }, 10000);

                }
                BX('QUANTITY_INPUT_' + id).value = item.QUANTITY;
                BX('QUANTITY_INPUT_' + id).defaultValue = item.QUANTITY;

                BX('QUANTITY_' + id).value = item.QUANTITY;
            }
        }
    }

    /*$('.header-cart .header-cart-price').text(res.BASKET_DATA['allSum_FORMATED']);
     $('.header-cart .header-cart-count').text(all_QUANTITY + ' ' + DeclOfNum(all_QUANTITY, ['товар', 'товара', 'товаров']));*/
    //window.reloadMiniBasket();

    // update coupon info
    if (BX('coupon')) {
		
        var couponClass = "";

        if (BX('coupon_approved') && BX('coupon').value.length == 0) {
            BX('coupon_approved').value = "N";
        }

        if (res.hasOwnProperty('VALID_COUPON')) {
            couponClass = (!!res['VALID_COUPON']) ? 'input-module good' : 'input-module bad';

            if (BX('coupon_approved')) {
                BX('coupon_approved').value = (!!res['VALID_COUPON']) ? 'Y' : 'N'
            }
        }

        if (BX('coupon_approved') && BX('coupon').value.length > 0) {
            couponClass = BX('coupon_approved').value == "Y" ? "input-module good" : "input-module bad";
        } else {
            couponClass = "input-module";
        }

        BX('coupon').className = couponClass;
    }

    if (BX('discount_card')) {
        var cardClass = "input-module";
        if (res['status'] === res['status_applyed']) {
            cardClass = "input-module good";
            BX('DISCOUNT_PRICE_ALL_FORMATED').innerHTML = (res['BASKET_DATA']['DISCOUNT_PRICE_ALL'] > 0) ? '-' + res['BASKET_DATA']['DISCOUNT_PRICE_ALL_FORMATED'] : '';
        } else if (res['status'] === res['status_not_found']) {
            cardClass = "input-module bad";
        }
        BX('discount_card').className = cardClass;
        if (
            typeof res['status_text'] !== typeof undefined &&
            res['status_text'].length > 0 &&
            BX('discount-card-status-text')
        ) {
            BX('discount-card-status-text').innerHTML = res['status_text'];
        }
        var $userPhone = $('input[name="PERSONAL[PHONE]"]'),
            $userFio = $('input[name="PERSONAL[FIO]"]');
        if (
            typeof res['card_data']['user_phone_formatted'] !== typeof undefined &&
            res['card_data']['user_phone_formatted'].length > 0
        ) {
            $userPhone.val(res['card_data']['user_phone_formatted']);
            $("input.js-phone-mask").mask("+7 (999) 9999999");
        }
        if (
            typeof res['card_data']['holder_full_name'] !== typeof undefined &&
            res['card_data']['holder_full_name'].length > 0
        ) {
            $userFio.val(res['card_data']['holder_full_name']);
        }
    }

	if (res['BASKET_DATA']['COUPON'].length > 0) {
	    // BX('DISCOUNT_VALUE_FORMATED').innerHTML = res['BASKET_DATA']['COUPON_LIST'][0]['DISCOUNT_NAME'];
		BX('DISCOUNT_PRICE_ALL_FORMATED').innerHTML = (res['BASKET_DATA']['DISCOUNT_PRICE_ALL'] > 0) ? '-' + res['BASKET_DATA']['DISCOUNT_PRICE_ALL_FORMATED'] : '';
	}
	else {
	    // BX('DISCOUNT_VALUE_FORMATED').innerHTML = '';
		BX('DISCOUNT_PRICE_ALL_FORMATED').innerHTML = '';
	}
	
    // update warnings if any
    if (res.hasOwnProperty('WARNING_MESSAGE')) {
        var warningText = '';

        for (var i = res['WARNING_MESSAGE'].length - 1; i >= 0; i--)
            warningText += res['WARNING_MESSAGE'][i] + '<br/>';

        BX('warning_message').innerHTML = warningText;
    }

    // update total basket values
    if (BX('allWeight_FORMATED'))
        BX('allWeight_FORMATED').innerHTML = res['BASKET_DATA']['allWeight_FORMATED'].replace(/\s/g, '&nbsp;');

    if (BX('allSum_wVAT_FORMATED'))
        BX('allSum_wVAT_FORMATED').innerHTML = res['BASKET_DATA']['allSum_wVAT_FORMATED'].replace(/\s/g, '&nbsp;');

    if (BX('allVATSum_FORMATED'))
        BX('allVATSum_FORMATED').innerHTML = res['BASKET_DATA']['allVATSum_FORMATED'].replace(/\s/g, '&nbsp;');

    if (BX('allSum_FORMATED'))
        BX('allSum_FORMATED').innerHTML = res['BASKET_DATA']['allSum_FORMATED'];

    if (BX('header_allSum_FORMATED'))
        BX('header_allSum_FORMATED').innerHTML = res['BASKET_DATA']['allSum_FORMATED'];

    if (BX('all_Quantity'))
        BX('all_Quantity').innerHTML = all_QUANTITY;

    if (BX('header_all_Quantity'))
        BX('header_all_Quantity').innerHTML = all_QUANTITY + ' ' + DeclOfNum(all_QUANTITY, ['товар', 'товара', 'товаров']);

    if (BX('PRICE_WITHOUT_DISCOUNT'))
        BX('PRICE_WITHOUT_DISCOUNT').innerHTML = (res['BASKET_DATA']['PRICE_WITHOUT_DISCOUNT'] != res['BASKET_DATA']['allSum_FORMATED']) ? res['BASKET_DATA']['PRICE_WITHOUT_DISCOUNT'].replace(/\s/g, '&nbsp;') : '';
	
	//Страница оформление заказа
	if (typeof window.delivery == "boolean" && window.delivery == true) {
		
		var $form = $("form[name=order_form]")
		
		//Общая сумма
		$(".basket-all-sum", $form).val(res['BASKET_DATA']['allSum'])
		$(".sum_FORMATED span", $form).html(res['BASKET_DATA']['allSum_FORMATED'])
		$(".allSum_FORMATED span", $form).html(res['BASKET_DATA']['allSum_FORMATED'])
		$("span.price-without-discount", $form).html(res['BASKET_DATA']['PRICE_WITHOUT_DISCOUNT'])
		$(".coupon span.discount-price-all-formated", $form).html(res['BASKET_DATA']['DISCOUNT_PRICE_ALL_FORMATED'])
		$(".coupon span.coupon-name", $form).html(res['BASKET_DATA']['COUPON'])
		
		$(".delivery_type_name", $form).addClass("hidden")
		if (res['BASKET_DATA']['DISCOUNT_PRICE_ALL'] == "0") {
			$(".info > div.coupon", $form).addClass("hidden")
		} else $(".info > div.coupon", $form).removeClass("hidden")
		$(".info > div.extraPrice", $form).addClass("hidden")
		
		if ($(".cart-goods tr.custom-product").length == 0) {
			$(".custom-products").remove();
			$("button.payoffline").removeClass("hidden")
		}
		
		if (typeof window.get_logistic_points == "function")
			window.get_logistic_points()
		if (typeof window.get_post_price == "function")
			window.get_post_price()
		if (typeof window.get_courier_price == "function")
			window.get_courier_price()
		
	}
	
}

function getColumnName(result, columnCode) {
    if (BX('col_' + columnCode)) {
        return BX.util.trim(BX('col_' + columnCode).innerHTML);
    }
    else {
        return '';
    }
}

function leftScroll(prop, id, count) {
    count = parseInt(count, 10);
    var el = BX('prop_' + prop + '_' + id);

    if (el) {
        var curVal = parseInt(el.style.marginLeft, 10);
        if (curVal <= (6 - count) * 20)
            el.style.marginLeft = curVal + 20 + '%';
    }
}

function rightScroll(prop, id, count) {
    count = parseInt(count, 10);
    var el = BX('prop_' + prop + '_' + id);

    if (el) {
        var curVal = parseInt(el.style.marginLeft, 10);
        if (curVal > (5 - count) * 20)
            el.style.marginLeft = curVal - 20 + '%';
    }
}

function checkOut() {
    BX("basket_form").submit();
    return true;
}

function enterCoupon() {

    //var value = parseInt(BX('coupon').value);

    //ID менеджера
    if ($.isNumeric(BX('coupon').value) && BX('coupon').value > 0) {
        BX('coupon').classList.add('good');
        return;
    }

    recalcBasketAjax();

}

function enterDiscountCard() {

    var value = parseInt(BX('discount_card').value.replace(/\D/g,''));

    if (value > 0) {
        recalcBasketAjax();
    }

}

// check if quantity is valid
// and update values of both controls (text input field for PC and mobile quantity select) simultaneously
function updateQuantity(controlId, basketId, ratio, bUseFloatQuantity) {

    validateMaxItems();

    var oldVal = BX(controlId).defaultValue,
        newVal = parseFloat(BX(controlId).value) || 0,
        bIsCorrectQuantityForRatio = false;

    if (ratio === 0 || ratio == 1) {

        bIsCorrectQuantityForRatio = true;

    } else {

        var newValInt = newVal * 10000,
            ratioInt = ratio * 10000,
            reminder = newValInt % ratioInt,
            newValRound = parseInt(newVal);

        if (reminder === 0) {
            bIsCorrectQuantityForRatio = true;
        }

    }

    var bIsQuantityFloat = false;

    if (parseInt(newVal) != parseFloat(newVal)) {
        bIsQuantityFloat = true;
    }

    newVal = (bUseFloatQuantity === false && bIsQuantityFloat === false) ? parseInt(newVal) : parseFloat(newVal).toFixed(2);

    if (newVal == 0) {
        delete_basket_item_show(basketId);
        return false;
    }

    if (bIsCorrectQuantityForRatio) {

        BX(controlId).defaultValue = newVal;
        BX("QUANTITY_INPUT_" + basketId).value = newVal;
        BX("QUANTITY_" + basketId).value = newVal;

        recalcBasketAjax();

    } else {

        newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);

        if (newVal != oldVal) {

            BX("QUANTITY_INPUT_" + basketId).value = newVal;
            BX("QUANTITY_" + basketId).value = newVal;
            recalcBasketAjax();

        } else {

            BX(controlId).value = oldVal;

        }
    }
}

// used when quantity is changed by clicking on arrows
function setQuantity(basketId, ratio, sign, bUseFloatQuantity) {
    var curVal = parseFloat(BX("QUANTITY_INPUT_" + basketId).value),
        newVal;

    newVal = (sign == 'up') ? curVal + ratio : curVal - ratio;


    if (newVal < 0)
        newVal = 0;
    if (newVal == 0) {
        delete_basket_item_show(basketId);
        return false;
    }

    if (bUseFloatQuantity) {
        newVal = newVal.toFixed(2);
    }

    if (ratio > 0 && newVal < ratio) {
        newVal = ratio;
    }

    if (!bUseFloatQuantity && newVal != newVal.toFixed(2)) {
        newVal = newVal.toFixed(2);
    }

    newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);


    BX("QUANTITY_INPUT_" + basketId).value = newVal;
    BX("QUANTITY_INPUT_" + basketId).defaultValue = newVal;


    updateQuantity('QUANTITY_INPUT_' + basketId, basketId, ratio, bUseFloatQuantity);
}


function getCorrectRatioQuantity(quantity, ratio, bUseFloatQuantity) {
    var newValInt = quantity * 10000,
        ratioInt = ratio * 10000,
        reminder = newValInt % ratioInt,
        result = quantity,
        bIsQuantityFloat = false,
        ratio = parseFloat(ratio);


    if (reminder === 0) {
        return result;
    }

    if (ratio !== 0 && ratio != 1) {
        for (var i = ratio, max = parseFloat(quantity) + parseFloat(ratio); i <= max; i = parseFloat(parseFloat(i) + parseFloat(ratio)).toFixed(2)) {
            result = i;
        }

    } else if (ratio === 1) {
        result = quantity | 0;
    }

    if (parseInt(result) != parseFloat(result)) {
        bIsQuantityFloat = true;
    }

    result = (bUseFloatQuantity === false && bIsQuantityFloat === false) ? parseInt(result) : parseFloat(result).toFixed(2);
    return result;
}

function hide_delete_pop_up() {
    $('.delete-basket-item').hide();
    recalcBasketAjax();
}

function recalcBasketAjax() {

    BX.showWait('basket_items');
    $('.delete-basket-item').hide();

    var property_values = {},
        action_var = BX('action_var').value,
        items = BX('basket_items_table'),
        delayedItems = BX('delayed_items');

    var postData = {
        'sessid': BX.bitrix_sessid(),
        'site_id': BX.message('SITE_ID'),
        'props': property_values,
        'action_var': action_var,
        'select_props': BX('column_headers').value,
        'offers_props': BX('offers_props').value,
        'quantity_float': BX('quantity_float').value,
        'count_discount_4_all_quantity': BX('count_discount_4_all_quantity').value,
        'price_vat_show_value': BX('price_vat_show_value').value,
        'hide_coupon': BX('hide_coupon').value,
        'use_prepayment': BX('use_prepayment').value,
        'coupon': !!BX('coupon') ? BX('coupon').value : ""
    };

    if (BX('discount_card')) {
        postData['discount_card'] = BX('discount_card').value;
    }

    postData[action_var] = 'recalculate';

    if (!!items && items.rows.length > 0) {
        for (var i = 0; items.rows.length > i; i++)
            if (items.rows[i].id != '')
                postData['QUANTITY_' + items.rows[i].id] = BX('QUANTITY_' + items.rows[i].id).value;
    }

    if (!!delayedItems && delayedItems.rows.length > 0) {
        for (var i = 0; delayedItems.rows.length > i; i++)
            if (delayedItems.rows[i].id != '')
                postData['DELAY_' + delayedItems.rows[i].id] = 'Y';
    }

    BX.ajax({
        url: TEMPlATE_CART_PATH + '/ajax/ajax.php',
        method: 'POST',
        data: postData,
        dataType: 'json',
        onsuccess: function (result) {
            BX.closeWait('basket_items');
            updateBasketTable(null, result, postData);
            if (result.BASKET_DATA.ITEMS.AnDelCanBuy.length < 1) {
                $('.basket-empty').removeClass('_hidden').prev().addClass('_hidden');
                $(".priceSpan").remove();
            } else {
                updateDeliveryTypeBlock(result.QUANTITY_SHINY_DISKI);
            }
            if (result.PARAMS.CUSTOM_PRODUCTS !== true) {
                $('.bx_ordercart .cart-total-prepayment').hide();
            } else {
                $('.bx_ordercart .cart-total-prepayment').show();
            }
        }
    });
}

function updateDeliveryTypeBlock(qtyshinyDiski) {
    if(BX('current_city_id')) {
        var cur_city = BX('current_city_id').value;
        if(cur_city > 0 && ourCities.indexOf(cur_city) == -1 && qtyshinyDiski > 1) {
            $('.delivery-ship-type > div').addClass('hidden');
            $('.delivery-ship-type > div.DELIVERY_LOGISTIC_TC').removeClass('hidden');
        } else {
            $('.delivery-ship-type > div').removeClass('hidden');
        }
    }
}

function showBasketItemsList(val) {
    BX.removeClass(BX("basket_toolbar_button"), "current");
    BX.removeClass(BX("basket_toolbar_button_delayed"), "current");
    BX.removeClass(BX("basket_toolbar_button_subscribed"), "current");
    BX.removeClass(BX("basket_toolbar_button_not_available"), "current");

    BX("normal_count").style.display = 'inline-block';
    BX("delay_count").style.display = 'inline-block';
    BX("subscribe_count").style.display = 'inline-block';
    BX("not_available_count").style.display = 'inline-block';

    if (val == 2) {
        if (BX("basket_items_list"))
            BX("basket_items_list").style.display = 'none';
        if (BX("basket_items_delayed")) {
            BX("basket_items_delayed").style.display = 'block';
            BX.addClass(BX("basket_toolbar_button_delayed"), "current");
            BX("delay_count").style.display = 'none';
        }
        if (BX("basket_items_subscribed"))
            BX("basket_items_subscribed").style.display = 'none';
        if (BX("basket_items_not_available"))
            BX("basket_items_not_available").style.display = 'none';
    }
    else if (val == 3) {
        if (BX("basket_items_list"))
            BX("basket_items_list").style.display = 'none';
        if (BX("basket_items_delayed"))
            BX("basket_items_delayed").style.display = 'none';
        if (BX("basket_items_subscribed")) {
            BX("basket_items_subscribed").style.display = 'block';
            BX.addClass(BX("basket_toolbar_button_subscribed"), "current");
            BX("subscribe_count").style.display = 'none';
        }
        if (BX("basket_items_not_available"))
            BX("basket_items_not_available").style.display = 'none';
    }
    else if (val == 4) {
        if (BX("basket_items_list"))
            BX("basket_items_list").style.display = 'none';
        if (BX("basket_items_delayed"))
            BX("basket_items_delayed").style.display = 'none';
        if (BX("basket_items_subscribed"))
            BX("basket_items_subscribed").style.display = 'none';
        if (BX("basket_items_not_available")) {
            BX("basket_items_not_available").style.display = 'block';
            BX.addClass(BX("basket_toolbar_button_not_available"), "current");
            BX("not_available_count").style.display = 'none';
        }
    }
    else {
        if (BX("basket_items_list")) {
            BX("basket_items_list").style.display = 'block';
            BX.addClass(BX("basket_toolbar_button"), "current");
            BX("normal_count").style.display = 'none';
        }
        if (BX("basket_items_delayed"))
            BX("basket_items_delayed").style.display = 'none';
        if (BX("basket_items_subscribed"))
            BX("basket_items_subscribed").style.display = 'none';
        if (BX("basket_items_not_available"))
            BX("basket_items_not_available").style.display = 'none';
    }
}

function delete_basket_item_show(basketId) {
    $('#delete_cart_item_id').val(basketId);
    $('.delete-basket-item').show();
}

function DeclOfNum(iNumber, aEndings) {
    var sEnding, i;
    iNumber = iNumber % 100;
    if (iNumber >= 11 && iNumber <= 19) {
        sEnding = aEndings[2];
    }
    else {
        i = iNumber % 10;
        switch (i) {
            case (1):
                sEnding = aEndings[0];
                break;
            case (2):
            case (3):
            case (4):
                sEnding = aEndings[1];
                break;
            default:
                sEnding = aEndings[2];
        }
    }
    return sEnding;
}

function validateMaxItems(showPop) {
 
    $('.bx_ordercart .count-module-block, .cart-goods .count-module-block').each(function () {

        var block = $(this);
        var quantityBlock = block.find('.count-module');

        var item = {
            max: parseInt(quantityBlock.attr('max'), 10),
            current: parseInt(quantityBlock.val(), 10)
        };
        var min = parseInt(quantityBlock.attr('data-min-value'));
        if(min>1){
            item.max = item.max - item.max%min;
        }

        if (item.max > 0 && item.current > item.max) {

            var availCount = item.max,
                availTitle = DeclOfNum(item.max, ['товар', 'товара', 'товаров']),
                availWord = DeclOfNum(item.max, ['доступен', 'доступно', 'доступно']),
                block = $('.pop-available');
            block.find('.count-available').text(availCount);
            block.find('.count-title').text(availTitle);
            block.find('.count-word').text(availWord);
            quantityBlock.val(item.max).trigger('change');
            showpop(block);

        }

    });

    return true;
	
}

$(document).ready(function () {

    //Кнопка показать корзину
    $("body").on("click", "a.header-cart", function(e) {
        if ($(".js-pop-cart .cart-block .ajaxLoading.first").length > 0) {
            window.reloadMiniBasket();
        }
    })
	
	//Показываем корзину если есть параметр
	var cart = getUrlParameter("cart");
	if (cart == "Y")
		$("a.header-cart").trigger("click")

    $(".count-module").numeric({}, function(){
        validateMaxItems();
    });

    $("body").on("keydown", ".count-module", function(e){
        if (e.which == 13) {
            $(this).trigger("change")
            return false;
        }
    })

	$("body").on("click", ".delete-cart-item", function(e) {

        validateMaxItems();

        BX.showWait('basket_items');

        url = $(this).attr('href');
        datasend = {};
        item_id = $(this).data('id');

        $.ajax({
            url: url,
            type: "GET",
            data: datasend,
            async: true,
            success: function (response) {
                $('#' + item_id).remove();
                BX.closeWait('basket_items');
                recalcBasketAjax();
            },
            dataType: 'html'
        });

        return false;
    });

    $('.count-module, .count-module-control').on('change keyup click', function () {
        validateMaxItems();
        return true;
    });

    $('.closr').live('click', function () {
        $(this).parents('.popInfo').remove();
    });


    $('.delete-cart-item-confirm').click(function () {
        basketId = $('#delete_cart_item_id').val();
        $('.delete-basket-item').hide();
        $('.delete-cart-item[data-id="' + basketId + '"]').click();
    });


});

